module.exports = __webpack_public_path__ + "static/media/pytorch_logo.28a00358.png";